// PT-BR + EN translations
export const dictionaries = {
  "pt-BR": {
    nav: {
      how: "Como funciona",
      features: "Funcionalidades",
      pricing: "Preços",
      faq: "FAQ",
      cta: "Baixar app",
      menu: "Menu",
      close: "Fechar",
    },
    hero: {
      tag: "DISCIPLINE.OS // V0.1",
      title1: "Conquiste sua",
      title2: "dopamina.",
      subtitle:
        "GuardMind bloqueia Instagram, TikTok, YouTube e qualquer app que rouba seu tempo — até você completar metas reais. Pontos. Streak. Liga.",
      ctaPrimary: "Entrar na waitlist",
      ctaSecondary: "Ver como funciona",
      stats: {
        users: "na waitlist",
        focus: "min foco/dia",
        streak: "streak médio",
      },
      mockup: {
        bar: "DASHBOARD",
        points: "PONTOS // PTS",
        streak: "STREAK // DIAS",
        goal: "META ATIVA",
        study: "Estudo profundo",
        league: "LIGA OURO // RANK 12",
        unlock: "DESBLOQUEIO EM",
      },
    },
    problem: {
      label: "DIAGNÓSTICO // 03 SINTOMAS",
      title: "Seu cérebro está em modo barato.",
      subtitle:
        "Cada scroll é uma microdose de dopamina sem custo. Em 30 dias, foco vira luxo.",
      items: [
        {
          k: "01",
          t: "Scroll infinito",
          d: "4h+ por dia em apps que não te pagam, não te ensinam, não te curam.",
        },
        {
          k: "02",
          t: "Dopamina barata",
          d: "Notificações, likes, vídeos curtos: prazer instantâneo, recompensa zero.",
        },
        {
          k: "03",
          t: "Procrastinação ativa",
          d: "Você sabe o que fazer. Só não faz. E sente culpa depois.",
        },
      ],
    },
    how: {
      label: "PROTOCOLO // 03 PASSOS",
      title: "Conquistar é simples. Mole, não.",
      steps: [
        {
          k: "01",
          t: "Defina sua missão",
          d: "Estudo, fitness, leitura, meditação. Escolha apps a bloquear: IG, TikTok, YouTube, X.",
        },
        {
          k: "02",
          t: "Cumpra a meta",
          d: "Timer ativo. Acelerômetro confere movimento real (anti-cheat). Apps ficam offline até você terminar.",
        },
        {
          k: "03",
          t: "Ganhe pontos",
          d: "Suba ligas (Bronze → Prata → Ouro). Mantenha streak. Desbloqueie tema e badge.",
        },
      ],
    },
    features: {
      label: "ARSENAL // 06 MÓDULOS",
      title: "Tudo que disciplina precisa.",
      items: [
        {
          t: "Bloqueio nativo",
          d: "App-level, não DNS. Não dá pra burlar fechando o GuardMind.",
        },
        {
          t: "Anti-cheat",
          d: "Acelerômetro + GPS. Treino só conta se você se moveu.",
        },
        {
          t: "Ligas globais",
          d: "Bronze, Prata, Ouro. Sobe se cumpre, desce se falha.",
        },
        {
          t: "Streak protegido",
          d: "1 bypass/dia (Free) ou 3 (PRO). Salva o dia ruim.",
        },
        {
          t: "Modo família",
          d: "Pais regulam tela dos filhos sem briga (PRO).",
        },
        {
          t: "Export CSV/JSON",
          d: "Seus dados são seus. Exporte e analise como quiser.",
        },
      ],
    },
    beforeAfter: {
      label: "TRANSFORMAÇÃO // 30 DIAS",
      title: "Antes do GuardMind. Depois.",
      before: "ANTES",
      after: "DEPOIS",
      beforeItems: [
        "4h scrollando IG/TikTok",
        "Acordar e abrir o celular",
        "Procrastinar metas reais",
        "Sono fragmentado",
        "Culpa todo domingo",
      ],
      afterItems: [
        "45min controlados, com propósito",
        "Acordar e treinar 20min",
        "3 metas/dia cumpridas",
        "Sono profundo e regular",
        "Liga Ouro, streak 24",
      ],
    },
    pricing: {
      label: "PLANOS // 02 OPÇÕES",
      title: "Comece grátis. Suba quando o foco virar hábito.",
      monthly: "Mensal",
      yearly: "Anual",
      save: "Economize 42%",
      free: {
        name: "FREE",
        tag: "Sempre grátis",
        price: "R$ 0",
        priceUSD: "$ 0",
        period: "/sempre",
        cta: "Começar grátis",
        features: [
          "3 metas ativas",
          "3 apps bloqueáveis",
          "10 amigos",
          "Histórico 30 dias",
          "1 bypass/dia",
          "1 tema (escuro)",
          "Avatar padrão",
          "Sem modo família",
          "Sem export",
          "Suporte comunidade",
        ],
      },
      pro: {
        name: "PRO",
        tag: "Disciplina total",
        priceMonth: "R$ 12,90",
        priceMonthUSD: "$ 3,99",
        priceYear: "R$ 89,90",
        priceYearUSD: "$ 24,99",
        perMonth: "/mês",
        perYear: "/ano",
        cta: "Quero PRO",
        badge: "MAIS ESCOLHIDO",
        features: [
          "Metas ilimitadas",
          "Apps ilimitados",
          "Amigos ilimitados",
          "Histórico ilimitado",
          "3 bypasses/dia",
          "Badge exclusivo na liga",
          "Conta família",
          "Export CSV / JSON",
          "Todos os temas",
          "Avatares completos",
          "Suporte e-mail prioritário",
        ],
      },
    },
    testimonials: {
      label: "RELATOS // 03 OPERADORES",
      title: "Quem quebrou o ciclo.",
      items: [
        {
          name: "Lucas M.",
          role: "Estudante de medicina",
          q: "Voltei a ler 2h por dia. Em 6 semanas subi pra Liga Ouro. Não acredito que era TikTok que tava me sabotando.",
        },
        {
          name: "Renata S.",
          role: "Designer & criadora",
          q: "GuardMind é o único app que respeita o problema sem ser chato. O bloqueio funciona, o streak vicia, a comunidade puxa.",
        },
        {
          name: "André P.",
          role: "Atleta amador",
          q: "Anti-cheat por acelerômetro mudou tudo. Não dá pra trapacear treino. E quando você não trapaceia, ganha de verdade.",
        },
      ],
    },
    faq: {
      label: "FAQ // 06 PERGUNTAS",
      title: "Dúvidas frequentes.",
      items: [
        {
          q: "Como o bloqueio funciona?",
          a: "GuardMind usa APIs nativas (Screen Time no iOS, Digital Wellbeing no Android) para bloquear apps a nível de sistema. Não é DNS, não é VPN, não é truque — funciona mesmo offline.",
        },
        {
          q: "Posso burlar fechando o GuardMind?",
          a: "Não. O bloqueio fica registrado no SO. Desinstalar o GuardMind quebra o streak e zera pontos do dia (proteção anti-burla).",
        },
        {
          q: "O que é anti-cheat?",
          a: "Para metas físicas (treino, caminhada), usamos acelerômetro + GPS. Se o celular não se moveu, a meta não conta.",
        },
        {
          q: "Como funciona o bypass?",
          a: "Free: 1 bypass/dia (libera 5min sem perder streak). PRO: 3 bypasses/dia. Use quando precisar mesmo — emergência, trabalho, família.",
        },
        {
          q: "Posso cancelar o PRO quando quiser?",
          a: "Sim. Sem fidelidade, sem multa. Cancela direto na App Store / Play Store. Mantém os dados, perde só os benefícios PRO.",
        },
        {
          q: "Tem versão web ou desktop?",
          a: "GuardMind é mobile-first (iOS + Android). Acompanhamos seu progresso pela web só em modo leitura. Bloqueio é mobile.",
        },
      ],
    },
    cta: {
      label: "FINAL // ENTRE NA WAITLIST",
      title: "Pronto para conquistar sua dopamina?",
      subtitle:
        "1ª semana: 1.000 vagas para o beta fechado. Os primeiros pegam PRO grátis por 6 meses.",
      placeholder: "seu@email.com",
      button: "Quero entrar",
      loading: "Enviando...",
      success: "Você está na lista. Posição #",
      already: "Você já está na lista. Posição #",
      error: "Algo deu errado. Tente de novo em alguns segundos.",
      invalid: "E-mail inválido. Confere aí.",
      privacy: "Sem spam. Sem venda de dados. Cancela com 1 clique.",
    },
    footer: {
      tagline: "Earn your dopamine.",
      product: "Produto",
      company: "Companhia",
      legal: "Legal",
      links: {
        features: "Funcionalidades",
        pricing: "Preços",
        faq: "FAQ",
        about: "Sobre",
        contact: "Contato",
        blog: "Blog",
        privacy: "Privacidade",
        terms: "Termos",
      },
      copyright: "Todos os direitos reservados.",
      built: "Construído com disciplina em São Paulo.",
    },
    common: { soon: "Em breve" },
  },

  en: {
    nav: {
      how: "How it works",
      features: "Features",
      pricing: "Pricing",
      faq: "FAQ",
      cta: "Get app",
      menu: "Menu",
      close: "Close",
    },
    hero: {
      tag: "DISCIPLINE.OS // V0.1",
      title1: "Earn your",
      title2: "dopamine.",
      subtitle:
        "GuardMind blocks Instagram, TikTok, YouTube and any app stealing your time — until you finish real goals. Points. Streak. League.",
      ctaPrimary: "Join waitlist",
      ctaSecondary: "See how it works",
      stats: {
        users: "on waitlist",
        focus: "min focus/day",
        streak: "avg streak",
      },
      mockup: {
        bar: "DASHBOARD",
        points: "POINTS // PTS",
        streak: "STREAK // DAYS",
        goal: "ACTIVE GOAL",
        study: "Deep study",
        league: "GOLD LEAGUE // RANK 12",
        unlock: "UNLOCKS IN",
      },
    },
    problem: {
      label: "DIAGNOSIS // 03 SYMPTOMS",
      title: "Your brain is on cheap mode.",
      subtitle:
        "Every scroll is a free dopamine microdose. In 30 days, focus turns into a luxury.",
      items: [
        {
          k: "01",
          t: "Endless scroll",
          d: "4h+ a day on apps that don't pay you, teach you or heal you.",
        },
        {
          k: "02",
          t: "Cheap dopamine",
          d: "Notifications, likes, short clips: instant pleasure, zero reward.",
        },
        {
          k: "03",
          t: "Active procrastination",
          d: "You know what to do. You just don't. Then guilt comes.",
        },
      ],
    },
    how: {
      label: "PROTOCOL // 03 STEPS",
      title: "Earning is simple. Not easy.",
      steps: [
        {
          k: "01",
          t: "Set your mission",
          d: "Study, fitness, reading, meditation. Pick the apps to block: IG, TikTok, YouTube, X.",
        },
        {
          k: "02",
          t: "Hit the goal",
          d: "Live timer. Accelerometer confirms real movement (anti-cheat). Apps stay offline until done.",
        },
        {
          k: "03",
          t: "Earn points",
          d: "Climb leagues (Bronze → Silver → Gold). Keep streak. Unlock theme and badge.",
        },
      ],
    },
    features: {
      label: "ARSENAL // 06 MODULES",
      title: "Everything discipline needs.",
      items: [
        { t: "Native blocking", d: "App-level, not DNS. Closing GuardMind won't bypass it." },
        { t: "Anti-cheat", d: "Accelerometer + GPS. Workout only counts if you actually moved." },
        { t: "Global leagues", d: "Bronze, Silver, Gold. Climb when you commit, drop when you fail." },
        { t: "Streak shield", d: "1 bypass/day (Free) or 3 (PRO). Saves your bad days." },
        { t: "Family mode", d: "Parents regulate kids' screen time without fights (PRO)." },
        { t: "CSV/JSON export", d: "Your data is yours. Export and analyze however." },
      ],
    },
    beforeAfter: {
      label: "TRANSFORMATION // 30 DAYS",
      title: "Before GuardMind. After.",
      before: "BEFORE",
      after: "AFTER",
      beforeItems: [
        "4h scrolling IG/TikTok",
        "Wake up & open phone",
        "Procrastinate real goals",
        "Fragmented sleep",
        "Sunday guilt",
      ],
      afterItems: [
        "45min controlled, with purpose",
        "Wake up & 20min training",
        "3 daily goals completed",
        "Deep & regular sleep",
        "Gold league, streak 24",
      ],
    },
    pricing: {
      label: "PLANS // 02 OPTIONS",
      title: "Start free. Upgrade when focus becomes habit.",
      monthly: "Monthly",
      yearly: "Yearly",
      save: "Save 42%",
      free: {
        name: "FREE",
        tag: "Always free",
        price: "R$ 0",
        priceUSD: "$ 0",
        period: "/forever",
        cta: "Start free",
        features: [
          "3 active goals",
          "3 blockable apps",
          "10 friends",
          "30-day history",
          "1 bypass/day",
          "1 theme (dark)",
          "Default avatar",
          "No family mode",
          "No export",
          "Community support",
        ],
      },
      pro: {
        name: "PRO",
        tag: "Total discipline",
        priceMonth: "R$ 12,90",
        priceMonthUSD: "$ 3.99",
        priceYear: "R$ 89,90",
        priceYearUSD: "$ 24.99",
        perMonth: "/mo",
        perYear: "/yr",
        cta: "Get PRO",
        badge: "MOST CHOSEN",
        features: [
          "Unlimited goals",
          "Unlimited apps",
          "Unlimited friends",
          "Unlimited history",
          "3 bypasses/day",
          "Exclusive league badge",
          "Family account",
          "CSV / JSON export",
          "All themes",
          "Full avatars",
          "Priority email support",
        ],
      },
    },
    testimonials: {
      label: "REPORTS // 03 OPERATORS",
      title: "Who broke the loop.",
      items: [
        {
          name: "Lucas M.",
          role: "Med student",
          q: "I'm reading 2h/day again. Hit Gold league in 6 weeks. I can't believe TikTok was sabotaging me.",
        },
        {
          name: "Renata S.",
          role: "Designer & creator",
          q: "GuardMind is the only app that respects the problem without being annoying. Block works, streak hooks, community pulls.",
        },
        {
          name: "André P.",
          role: "Amateur athlete",
          q: "Accelerometer anti-cheat changed everything. You can't fake a workout. When you don't fake, you actually win.",
        },
      ],
    },
    faq: {
      label: "FAQ // 06 QUESTIONS",
      title: "Frequent questions.",
      items: [
        {
          q: "How does blocking work?",
          a: "GuardMind uses native APIs (Screen Time on iOS, Digital Wellbeing on Android) to block apps at OS-level. Not DNS, not VPN — works even offline.",
        },
        {
          q: "Can I bypass by closing GuardMind?",
          a: "No. The block lives at OS level. Uninstalling breaks the streak and zeroes today's points (anti-cheat).",
        },
        {
          q: "What is anti-cheat?",
          a: "For physical goals (training, walking) we use accelerometer + GPS. If the phone didn't move, the goal doesn't count.",
        },
        {
          q: "How do bypasses work?",
          a: "Free: 1 bypass/day (5min unlock without losing streak). PRO: 3 bypasses/day. Use only when truly needed.",
        },
        {
          q: "Can I cancel PRO any time?",
          a: "Yes. No commitment, no fees. Cancel in App/Play Store. You keep your data, lose only PRO perks.",
        },
        {
          q: "Is there a web/desktop version?",
          a: "GuardMind is mobile-first (iOS + Android). The web only shows progress in read-only. Blocking is mobile.",
        },
      ],
    },
    cta: {
      label: "FINAL // JOIN WAITLIST",
      title: "Ready to earn your dopamine?",
      subtitle:
        "Week 1: 1,000 spots for closed beta. First in get 6 months PRO free.",
      placeholder: "you@email.com",
      button: "Join now",
      loading: "Sending...",
      success: "You're in. Position #",
      already: "You're already in. Position #",
      error: "Something failed. Try again in a sec.",
      invalid: "Invalid email. Check it.",
      privacy: "No spam. No selling data. 1-click unsubscribe.",
    },
    footer: {
      tagline: "Earn your dopamine.",
      product: "Product",
      company: "Company",
      legal: "Legal",
      links: {
        features: "Features",
        pricing: "Pricing",
        faq: "FAQ",
        about: "About",
        contact: "Contact",
        blog: "Blog",
        privacy: "Privacy",
        terms: "Terms",
      },
      copyright: "All rights reserved.",
      built: "Built with discipline in São Paulo.",
    },
    common: { soon: "Soon" },
  },
};

export const supportedLocales = ["pt-BR", "en"];
